import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles<Theme>(theme => ({
  control: {
    '& div': {
      fontSize: theme.size.sm
    }
  },
  formGroup: {
    display: 'flex',
    alignItems: 'center'
  },

  calendarLabel: {
    marginRight: 8,
    userSelect: 'none',
    minWidth: 60
  },

  controlLabelBold: {
    fontSize: theme.size.sm,
    userSelect: 'none'
  },
  hover: {
    cursor: 'pointer'
  },
  dateContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  removeBtn: {
    marginLeft: 6,
    width: '0.8rem',
    heigth: '0.8rem'
  }
}))

export default useStyles
